import {EParameterType} from './definitions';

export default {
  parameter: 'Variable',
  chosenParameters: 'Selected variables',
  chosenParametersHint: 'Enter the values of the variables to be applied in the filter',
  choseParameters: 'Select variables: ',
  parameterValues: 'Variable values',
  findParameter: 'Search variable',
  availableParameters: 'Available variables',
  empty: {
    title: 'This is empty for now',
    nothingFound: 'Nothing found',
  },
  assignDialog: {
    title: 'Assign variable',
  },
  assignForm: {
    name: 'Name of the variable',
    type: 'Type of the variable',
    value: 'Value',
    create: 'Create a variable',
  },
  editForm: {
    title: 'Add a variable',
    name: 'Enter the name for the variable',
    valueType: 'Type of the variable',
  },
  removeDialog: {
    title: 'Delete variable?',
    text: 'Deleting a variable will permanently remove this piece of information about the recipient',
  },
  successDialog: {
    title: 'Great, variable added!',
    text: 'Now it’s even easier to personalize messages for this recipient',
    action: 'Cool',
  },
  valueType: {
    [EParameterType.STRING]: 'String',
    [EParameterType.BOOLEAN]: 'Boolean value',
    [EParameterType.DATE]: 'Date',
    [EParameterType.NUMBER]: 'Number',
  },
  boolean: {
    true: '{{name}} (True)',
    false: '{{name}} (False)',
  },
};
